// Groups that are only meant to be used inside their integrated-app session.
// If a Sparket-authenticated user lands on a contest from one of these groups
// without an active integration session, we hide the Enter button and filter
// the group out of the dropdown.
//
// Today this is just Soboba (Aristocrat opens Sparket in the external mobile
// browser, so the URL is shareable and Cognito-signed-in users can otherwise
// stumble into the contest with the wrong auth). Add more slugs here as
// integration-only partners are onboarded.
export const INTEGRATION_ONLY_GROUP_SLUGS = ["soboba"];

export const isIntegrationOnlyGroup = (groupUri?: string): boolean =>
  !!groupUri && INTEGRATION_ONLY_GROUP_SLUGS.includes(groupUri);
